import { useTranslation } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { Svg, Tag, Tooltip, type TooltipPlacement } from "@impero-com/ui";

import type { ControlPolicy } from "api/generated/model";
import lockSvg from "img/lock.svg";

interface ControlPolicyTagProps {
    policy: ControlPolicy;
    defaultTooltip: string;
    enforcedTooltip: string;
    placement?: TooltipPlacement;
}

export function ControlPolicyTag({
    policy,
    defaultTooltip,
    enforcedTooltip,
    placement = "top",
}: ControlPolicyTagProps) {
    const { t } = useTranslation();
    switch (policy.mode) {
        case "Default":
            return (
                <Tooltip title={defaultTooltip} placement={placement} noWrapper>
                    <Tag variant="neutral">{t("Control_Policy_Default")}</Tag>
                </Tooltip>
            );
        case "Enforced":
            return (
                <Tooltip
                    title={enforcedTooltip}
                    placement={placement}
                    noWrapper
                >
                    <Tag variant="lightBlue" icon={<Svg src={lockSvg} />}>
                        {t("Control_Policy_Enforced")}
                    </Tag>
                </Tooltip>
            );
        default:
            return assertNever(policy);
    }
}
